import { Input,Component } from '@angular/core';
import { LocalizeService } from '../services/localize.service';

@Component({
  selector: 'edx-toggle-switch',
  styleUrls: ['toggle-switch.component.scss'],
  templateUrl: 'toggle-switch.component.html',
  standalone: false
})
export class ToggleSwitchComponent {
  public isDisabled = false;
  public altLabels;
  @Input() label: string;
  @Input() desc;
  @Input() callback;
  @Input() isChecked = false;

  constructor(private localizer: LocalizeService) {
    this.altLabels = {
      enabled: this.localizer.getTranslation('ADMIN.FOOTER.ENABLE'),
      disabled: this.localizer.getTranslation('ADMIN.GROUPS.DISABLED')
    };
  }
  public toggle() {
    if (!this.isDisabled) {
      this.isChecked = !this.isChecked;
      this.callback.toggle(this.isChecked, this.desc);
    }
  }

  public getAriaLabelForToggle(): string {
    return this.desc.name + ' ' + (this.isChecked ? this.altLabels.enabled : this.altLabels.disabled);
  }
}
